import React, { Fragment } from "react";
import Seo from "../../components/utils/Seo";
import BodyLoginAdmin from "./BodyLoginAdmin";
import Base from "../Base";

const LoginPage = (props) => {
  return (
    <Fragment>
      <Seo
        title="nti / connexion / admin"
        description="Connectez-vous pour administrer votre boutique"
      />
      <Base>
        <BodyLoginAdmin />
      </Base>
    </Fragment>
  );
};

export default LoginPage;
